export const streetAddressValidator = {
  maxLength: {
    value: 50,
    message: '住所は50文字以下で入力してください',
  },
};
